var RPMToRad = 1/9.5492965964254
var ozInToNm = 1/141.61193227806

var AM40 = {
    name: 'Andymark 40',
    stall_current: 11.5, // amps
    free_speed: 16.7551608, // rad/s
    stall_torque: 2.47154314166666, // Newton-meters
    voltage_used: 12, // volts
    back_drive: 0.0903878634666663,
    cpr: 1120 // counts per revolution
}

var AM20 = {
    name: 'Andymark 20',
    stall_current: 11.5, // amps
    free_speed: 30.892327725, // rad/s
    stall_torque: 1.39112571116666, // Newton-meters
    voltage_used: 12, // volts
    back_drive: 0, // not available
    cpr: 560 // counts per revolution
}

var AM60 = {
    name: 'Andymark 60',
    stall_current: 11.5, // amps
    free_speed: 105 * RPMToRad, // rad/s
    stall_torque: 593 * ozInToNm, // Newton-meters
    voltage_used: 12, // volts
    back_drive: 0, // not available
    cpr: 1680
}

var AMOrbital = {
    name: 'Andymark Orbital',
    stall_current: 11.5, // amps
    free_speed: 35.6047167, // rad/s
    stall_torque: 1.23577157083333, // Newton-meters
    voltage_used: 12, // volts
    back_drive: 0, // not available
    cpr: 537.6 // counts per revolution
}

class DcMotor {
    constructor(motor_type, mass, wheel_mass, wheel_radius, num_wheels) {
		this.stall_current = motor_type.stall_current // amps
		this.free_speed = motor_type.free_speed // rad/s
        this.stall_torque = motor_type.stall_torque // Newton-meters
        this.voltage_used = motor_type.voltage_used // volts
        this.back_drive = motor_type.back_drive // Newton-meters
        this.cpr = motor_type.cpr // counts per revolution

        this.current_voltage = 0
        this.torque = 0
        this.angular_velocity = 0
        this.radians_travelled = 0
        this.previous_voltage = 0

        this.mass = wheel_mass // kg of Vex Pro mecanum wheels
        this.robot_mass = mass / num_wheels // kg of robot over each wheel
        this.num_wheels = num_wheels
        this.wheel_radius = wheel_radius // meters make sure to change in streams also if necessary
        this.moment_of_inertia = wheel_mass * Math.pow(this.wheel_radius, 2) / 2

        this.special2 = ((this.moment_of_inertia / this.wheel_radius) + (this.wheel_radius * this.robot_mass))
		this.k_v = this.free_speed / this.voltage_used
		this.resistance = this.voltage_used / this.stall_current
		this.k_t = this.stall_torque / this.stall_current
    }

    setPower(power) {
        this.current_voltage = Math.max(-12, Math.min(12, power*12))
    }

    getPower() {
        return this.current_voltage
    }

    getTorque() {
        return this.torque
    }

    getForce() {
        return this.acc * this.robot_mass
    }

    simulate(dt) {
        let current = (this.current_voltage - (this.angular_velocity / this.k_v)) / this.resistance;
        this.torque = this.k_t * current
        this.acc = this.torque / this.special2
        let ang_acc = this.acc / this.wheel_radius
        this.angular_velocity += ang_acc * dt
		this.radians_travelled += this.angular_velocity * dt
    }

    resetAngularVelocity() {
        this.angular_velocity = 0
    }
    
    reset() {
        this.previous_voltage = 0
        this.current_voltage = 0
        this.torque = 0
        this.angular_velocity = 0
        this.radians_travelled = 0
    }
	
	getVelocity() {
		return this.angular_velocity
	}
	
	getCurrentPosition() {
		return (this.radians_travelled / (2 * Math.PI)) * this.cpr
	}
}

export { DcMotor, AM40, AM20, AMOrbital }



//////////////////
// WEBPACK FOOTER
// ./src/DcMotor.js
// module id = 8
// module chunks = 0